module.exports = __webpack_public_path__ + "static/Roxanne-Aguirre-Grandma-56e9f0dc5c18920c43a7e0d2bf26b10b.jpg";